import * as d from "shared/src/date.mjs";

const appointmentDelayedBy = (appointmentTime) => {
  const now = new Date();
  const appointment = d.parseDateTime(appointmentTime);
  // Use getTime() for type-safe subtraction under TypeScript / JS type checking.
  const diff = now.getTime() - appointment.getTime();
  if (diff < 0) {
    return 0;
  }
  const totalMinutes = Math.floor(diff / 1000 / 60);

  return totalMinutes;
};

/**
 * Minutes since the last time the appointment changed to the given status.
 *
 * Returns Infinity if the appointment never entered that status.
 *
 * @param {Appointment|object} appointment Appointment object containing audit history (appointment.audit.data).
 * @param {number} statusId Status identifier constant (e.g. status.TREATED).
 * @returns {number} Minutes elapsed since the last change to the given status. Infinity if no such change has occurred.
 */
const lastAppointmentStateChangeIn = (appointment, statusId) => {
  if (
    !appointment ||
    !appointment.audit ||
    !Array.isArray(appointment.audit.data)
  ) {
    return Infinity;
  }

  const data = appointment.audit.data;
  if (data.length === 0) {
    return Infinity;
  }
  const target = String(statusId);
  // Find the most recent audit record where status_id changed to the target status.
  for (let i = data.length - 1; i >= 0; i--) {
    const change = data[i];
    const changedTo = change?.changed_fields?.status_id;
    if (changedTo != null && String(changedTo) === target) {
      const changedAt = d.parseUtcDateTime(change.created_at);
      if (changedAt) {
        return Math.floor((Date.now() - changedAt.getTime()) / 60000);
      }
    }
  }

  return Infinity;
};

const searchAppointments = (appointments, searchTerm, statuses = []) => {
  const searchTerms = searchTerm.split(" ").map((term) =>
    term
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, ""),
  );

  let filteredAppointments = appointments;
  if (statuses.length) {
    filteredAppointments = filteredAppointments.filter((appointment) =>
      statuses.includes(appointment.status_id),
    );
  }
  searchTerms.forEach((term) => {
    filteredAppointments = filteredAppointments.filter(
      (appointment) =>
        appointment.client.first_name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .includes(term) ||
        appointment.client.last_name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .includes(term) ||
        String(appointment.client.labs_id ?? "").includes(term) ||
        appointment.client.birth_number?.includes(term) ||
        appointment.client.phone?.includes(term) ||
        appointment.start.split(" ")[1].includes(term) ||
        appointment.start.split(" ")[1].replace(":", "").includes(term),
    );
  });
  return filteredAppointments;
};

export {
  lastAppointmentStateChangeIn,
  appointmentDelayedBy,
  searchAppointments,
};
